import { inject, Injectable } from '@angular/core';
import { SurveyApi } from '../../api/survey.api';
import { Survey } from '../../models/survey.model';
import { Observable } from 'rxjs';
import { GetSurveysDto } from '../../api/dtos/survey.dto';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  private readonly _api = inject(SurveyApi);

  public getSurveys(data: GetSurveysDto): Observable<Survey[]> {
    return this._api.getSurveys(data);
  }
}
